import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=2f14c9b4&scoped=true&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=2f14c9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14c9b4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/footerNav.vue
// module id = null
// module chunks = 